export const enMessage = {
  Chinese: 'Chinese',
  English: 'English',
  common: {
    login: '登录'
  },
  system: {
    id_type: '系统管理员'
  },
  student: {
    id_type: '学员'
  },
  setting: {
    setting: 'Setting',
    unit: 'Unit Setting',
    person: 'Person Setting'
  },
  userName: 'ID Number',
  password: 'Password',
  passwordLimit: '8-16 bits , case sensitive and numbers',
  oldPassword: 'Old Password',
  oldPasswordPlaceholder: 'Please enter the old password',
  newPassword: 'New Password',
  newPasswordPlaceholder: 'Please enter the new password',
  confirmPassword: 'Confirm Password',
  confirmPasswordLimit: 'The two passwords don\'t match',
  confirmPasswordPlaceholder: 'Please enter the confirm password',
  modify: 'Modify',
  permission: 'Permission',
  editPassword: 'Edit Password',
  editPhone: 'Edit Phone',
  home: 'Home',
  refresh: 'Refresh',
  quit: 'Quit',
  coach: 'Coach',
  coachAccount: 'Coach Account',
  coachName: 'Name',
  coach1: 'Coach',
  coachPlaceholder: 'Please select the executive coach',
  coachInformation: 'Coach Information',
  trainer: 'Trainer',
  trainerName: 'Trainer Name',
  title: 'Information platform of China football association national brand team teaching plan system',
  competent: 'Competent',
  chineseFootballAssociation: 'Chinese Football Association',
  service: 'Service',
  serviceWeChat: 'Service WeChat',
  technicalSupport: 'Technical Support',
  telephone: 'Telephone',
  phone: 'Telephone',
  mobilePhoneNumber: 'Mobile Phone',
  mobilePhonePlaceholder: 'Please enter the correct mobile phone number',
  registeredPhone: 'The phone number has been registered',
  registeredIdNumber: 'The identification number has been registered',
  newMobilePhoneNumber: 'New Mobile Phone',
  newMobilePhoneNumberPlaceholder: 'Please enter the new mobile phone',
  warmTips: 'Warm tips: after successful modification, please use the new mobile phone number to log in',
  code: 'Verification Code',
  codePlaceHolder: 'please enter the verification code',
  codeFormatTips: 'please enter the  correct verification code',
  yioks: 'Yioks',
  playerManagement: 'Player Management',
  addPlayer: 'Add One Player',
  addLeader: 'Add One Leader',
  editLeader: 'Edit Leader',
  bulkImportPlayers: 'Bulk Import Players',
  bulkImportLeaders: 'Bulk Import Leaders',
  bulkImportCoaches: 'Bulk Import Coaches',
  allPlayers: 'All Players',
  namePlaceholder: 'Please enter the name',
  phonePlaceholder: 'Please enter the phone',
  search: 'Search',
  edit: 'Edit',
  delete: 'Delete',
  bindingTeam: 'Binding Team',
  editPlayer: 'Edit Player',
  name: 'Name',
  team: 'Team',
  teams: 'All Grades',
  teamPlayers: 'Team Players',
  playersNum: 'Players Num',
  team1: 'Technical Grade ',
  position: 'Position',
  unit: 'Unit',
  profilePhoto: 'Profile Photo',
  headPortrait: 'Photo',
  operation: 'Operation',
  idNumber: 'ID Number',
  keyWordsPlaceholder: 'Please enter the keyWords',
  idNumberPlaceholder: 'Please enter the identification number',
  positionPlaceholder: 'Please select the player\'s position',
  unitName: 'Unit Name',
  unitPlaceholder: 'Please enter the unit name',
  unitPhonePlaceholder: 'Please enter the unit contact number',
  teamPlaceholder: 'Please select the team of player',
  SquadNameBusy: 'The team name has been taken',
  MasterCoachBusy: 'The executive coach already exists on tempApi teams',
  LeaderBusy: 'The leader already exists on tempApi teams',
  CoachBusy: 'Coach data is being updated, please refresh the page and try again',
  confirm: 'Confirm',
  save: 'Save',
  cancel: 'Cancel',
  deletePlayerTips: 'Make sure to delete the player ?',
  deleteTeamTips: 'Make sure to delete the team ?',
  nameTips: 'Please enter the name',
  idNumberTips: 'Please enter the correct identification number',
  playerInformation: 'Player Information',
  basicInformation: 'Basic Information',
  age: 'Age',
  gender: 'Gender',
  genderPlaceholder: 'Please select the gender',
  birthday: 'Birthday',
  birthPlace: 'Birthplace',
  leader: 'Leader',
  leaderAccount: 'Leader Account',
  leaderStatus: 'Leader Status',
  leaderInformation: 'Leader information',
  leaderName: 'Leader',
  leaderPlaceholder: 'Please select the leader',
  executiveCoach: 'Executive Coach',
  coachTeams: 'Coach Teams',
  players: 'Players',
  player: 'Player',
  managementTeam: 'Management Team',
  teamManagement: 'Team Management',
  trainingTimeStatistics: 'Training time statistics',
  totalTrainingTime: 'Total Training Time',
  hour: 'Hour',
  hours: 'Hours',
  minutes: 'minutes',
  minute: 'minute',
  people: '',
  editTeam: 'Edit Team',
  teachingPlansNum: 'Number of teaching plans',
  private: 'Private',
  internal: 'Internal',
  look: 'Look Over',
  adjustPlayer: 'Adjust players',
  uploadFormat: 'Support JPG,jpeg, BMP, GIF, PNG format upload',
  fileSizeLimit: 'The size of the uploaded image cannot exceed 10MB',
  uploadTipsFirst: 'Please upload excel file',
  or: ' or ',
  uploadTipsSecond: 'download template',
  uploadTipsThird: ' after editing',
  quitTips: 'Make sure to log out？',
  noData: 'No data at present~',
  clickOnUpload: 'Click on the upload',
  hardLoading: 'Hard loading...',
  addTeam: 'Add Team',
  addCoach: 'Add One Coach',
  editCoach: 'Edit Coach',
  coachStatus: 'Coach Status',
  totalTeamNums: 'Total Teams',
  all: 'All',
  teamName: 'Team Name',
  shortName: 'Short Name',
  shortNamePlaceholder: 'Please select team first',
  waivedSubmission: 'Make sure to Discard changes and return?',
  temporarilySaveAndReturn: 'Make sure to temporarily save and return?',
  saveAndReturnPre: 'Make sure to temporarily save and return previous step?',
  status: 'Status',
  allLeaders: 'All Leaders',
  allCoaches: 'All Coaches',
  loginTips: '* The mobile phone number will be used as the initial password of the leader, and the id number will be used as the login account',
  teachingPlans: 'Teaching Plans',
  createdTeachingPlans: 'Teaching Plans',
  total: 'Total',
  more: 'More',
  addPlayersTips: 'Click "+" to add player',
  removePlayersTips: 'Click "-" to remove player',
  otherPlayers: 'Other Players',
  existingPlayers: 'Existing Players',
  trainingPlan: 'Training Plan',
  trainingPlanPlaceholder: 'Please enter the training plan',
  planNamePlaceholder: 'Please enter the name of plan',
  completedPlan: 'Completed',
  pendingPlan: 'Pending',
  writingPlan: 'Writing',
  addPlan: 'Add Plan',
  trainingStartTime: 'Training Start Time',
  download: 'Download',
  completedConfirm: 'Confirm',
  deletePlanTips: 'Make sure to delete the training plan？',
  backPlanTips: 'Make sure to back the training plan？',
  deleteTeachingPlanTips: 'Make sure to delete the teaching plan？',
  addOrEditPlan: 'Add Or Edit Training Plan',
  writingPlanStepOne: 'Step 1: Write a plan',
  writingPlanStepTwo: 'Step 2:  Confirm the plan',
  writingPlanStepThree: 'Step 3: Evaluate the plan',
  chiefCoach: 'Chief Coach',
  train: 'Train',
  trainingVolume: 'Training Volume',
  trainingIntensity: 'Training Intensity',
  trainingPlanDescription: 'Training Plan Description',
  choosePlan: 'Choose Template',
  templatePlan: 'Template of plan',
  templatePlanTips: 'Please choose a template of plan',
  trainingPlace: 'Training Place',
  placeTips: 'Please enter the training place',
  nextStep: 'Next Step',
  previousStep: 'Previous Step',
  temporarilySave: 'Temporarily Save',
  timePlaceholder: 'Please select the training time ',
  trainingTopic: 'Training Topic',
  linkTitle: 'Link Title',
  planTitle: 'Plan Title',
  show: 'Which Show',
  linkDescription: 'Link Description',
  generalDescription: 'General Description',
  trainingDescription: 'Training Description',
  trainingTopicPlaceholder: 'Please enter the training topic',
  classification: 'Classification',
  type: 'Type',
  classifications: 'Classifications',
  classificationPlaceholder: 'Please select the classification topic',
  trainingDuration: 'Cost Time(minutes)',
  totalTimes: 'Total Times(minutes)',
  author: 'Author',
  lastUpdateTime: 'Last Update Time',
  language: 'Language',
  confirmPlan: 'Confirm Plan',
  planSearchTips: 'Please enter the name of plan',
  noFlashTips: 'The browser did not start or install Flash Player, so it cannot play properly ~~',
  youCan: 'you can ',
  startFlash: 'enable or install the Flash Player immediately',
  confirmRoster: 'Confirm the team\'s roster',
  open: 'Open',
  close: 'Close',
  group: 'Group',
  groupA: 'Group-A',
  groupB: 'Group-B',
  mustOnePlayer: 'Every group has at least one player',
  iKnow: 'I know',
  trainingSummary: 'Training Summary',
  playersAttendance: 'Players In Attendance',
  attendance: 'Attendance',
  playerEvaluation: 'Whether to conduct players evaluation',
  evaluation: 'Players Evaluation',
  trainingGoal: 'Training Goal',
  trainingGoalPlaceholder: 'Please enter the training goal',
  overallEvaluationOpinion: 'Overall Evaluation Opinion',
  overallEvaluationOpinionPlaceholder: 'Please enter the overall evaluation opinion',
  psychological: 'Psychological',
  physical: 'Physical',
  tactical: 'Tactical',
  technology: 'Technology',
  points: '',
  select: 'Please select one',
  defaultPlaceholder: 'Please enter something to describe',
  project: 'Project',
  duration: 'Duration',
  linkDuration: 'Link Duration',
  ge: '',
  yioksLibrary: 'Yioks Library',
  officialLibrary: 'Official Library',
  organLibrary: 'Organ Library',
  youthLibrary: 'Youth Library',
  myPlan: 'My Plans',
  collectionPlans: 'Collection of Plans',
  createPlan: 'Create Plan',
  createMatchPlan: 'Create Match Plan',
  quicklyCreate: 'Create  Quickly',
  confirmCreate: 'Confirm',
  collect: 'Collect',
  removeCollection: 'Remove Collection',
  copyPlan: 'Copy Plan',
  downloadPlan: 'Download Plan',
  editPlan: 'Edit Plan',
  editMatchPlan: 'Edit Match Plan',
  removePlan: 'Remove Plan',
  salute: 'Salute',
  allLinks: 'All Links',
  linkType: 'Link Type',
  link: 'Link',
  queryTrainingContent: 'Query The Training Content',
  professionalFootballCoach: 'Professional Football Coach',
  sharedPermission: 'Shared Permission',
  lookBySelf: 'Only You',
  sharedTeam: 'Only Your Team',
  provincePlaceholder: 'Please select  province',
  cityPlaceholder: 'Please select  city',
  uploadFileTips: 'Please delete the file before uploading',
  uploadExcelTips: 'Please upload the Excel file!',
  uploadExcelSizeTips: 'The file size must not exceed 20M！',
  importNow: 'Import Now',
  lookDetail: 'Look Detail',
  planLimitTips: 'A maximum of 5 links can be selected',
  planEditor: 'The Plan Editor',
  sendCode: 'Send Code',
  centerManagement: 'Center Management'
}
